<template>
  <div class="vip-data-card">
    <div class="card-title">
      <div class="">{{ label }}</div>
    </div>
    <div class="card-data">
      <div class="card-data-num">
        <span>{{ num }}</span>
        <span class="card-data-unit">{{ unit }}</span>
      </div>
      <div class="card-data-rate">
        <span v-if="rate > 0" style="color: #f53f3f">+{{ rate }}%</span>
        <span v-else-if="rate < 0">{{ rate }}%</span>
        <!-- <img src="@/assets/images/vip/data_up.png" /> -->
        <img
          v-if="rate > 0"
          class="decreaseIcon"
          :src="increaseImg"
          alt=""
          srcset=""
        />
        <img
          v-if="rate < 0"
          class="decreaseIcon"
          :src="decreaseImg"
          alt=""
          srcset=""
        />
      </div>
    </div>
    <!-- <div class="card-chart" ref="chart" style="width: 100%; height: 74px"></div> -->
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "VipCard",
  props: {
    label: {
      type: String,
      default: "会员收入总金额",
    },
    num: 0,
    unit: {
      type: String,
      default: "元",
    },
    rate: 0,
  },
  data() {
    return {
      // chartData: [0, 932, 901, 934, 1290, 1330],
      // categories: ["1月", "2月", "3月", "4月", "5月", "6月"],
      increaseImg: require("@/assets/images/increase@2x.png"),
      decreaseImg: require("@/assets/images/decrease@2x.png"),
    };
  },
  mounted() {
    // this.initChart();
  },
  beforeDestroy() {
    // 销毁图表实例，防止内存泄漏
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },
  methods: {
    initChart() {
      // 获取图表容器
      this.chartInstance = echarts.init(this.$refs.chart);
      const option = {
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.categories,
          show: false,
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          show: false,
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false, // 隐藏 Y 轴的标签
          },
          min: Math.min(...this.chartData), // 设置 Y 轴最小值为数据中的最小值
          max: Math.max(...this.chartData), // 设置 Y 轴最大值为数据中的最大值
        },
        grid: {
          show: false, // 去掉网格线
          containLabel: true, // 保证标签不被裁剪
          left: "0%", // 调整左边距，确保折线显示完整
          right: "10%", // 调整右边距
          top: "10%", // 调整上边距
          bottom: "0%", // 调整下边距
        },
        series: [
          {
            data: this.chartData,
            type: "line",
            smooth: false,
            symbol: "none",
            areaStyle: {
              // 设置渐变色区域
              type: "linear",
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(56, 107, 245, 0.3)" }, // 渐变的起始颜色
                { offset: 1, color: "rgba(56, 107, 245, 0)" }, // 渐变的结束颜色
              ]),
            },
          },
        ],
      };
      // 设置图表选项
      this.chartInstance.setOption(option);
    },
  },
};
</script>

<style scoped lang="less">
.vip-data-card {
  background: #ffffff;
  border-radius: 4px;
  padding: 15px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.card-title {
  font-weight: 600;
  font-size: 16px;
  color: #1d2129;
}
.card-data {
  display: flex;
  align-items: baseline;
  margin: 8px 0;
}
.card-data-num {
  font-weight: 400;
  font-size: 24px;
  color: #1d2129;
}
.card-data-unit {
  font-weight: 500;
  font-size: 14px;
  color: #1d2129;
  margin-left: 4px;
}
.card-data-rate {
  font-weight: 400;
  font-size: 14px;
  color: #00b42a;
  margin-left: 8px;
}
.decreaseIcon {
  width: 12px;
  height: 12px;
  margin-left: 4px;
}
</style>
